import React from "react";
import Headline from "./Headline";
import HomeLink from "../../widgets/HomeLink";

const bannerPath = '/iceholidays-assets/images/mice-banner.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Corporate' }
] 
const miceLogoPath = '/iceholidays-assets/images/mice-logo-new.png';

const MiceAboutPage = () => (

  <div className="mice-page">
    <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
      <span className="title">
        <img src={miceLogoPath} alt="MICE Logo"/>
      </span>
    </Headline>

    <div className="mice-page_body mice-page_body-about">
      <div id="header">
         <div> 
          <h1>
            GD MICE – Custom-Made Travel Solutions For Every Business Need
            <span>Meetings | Incentives | Conferences | Events</span>
          </h1>
          
        </div> 
       
        <div id="header-image"><img src="/iceholidays-assets/images/mice-bg.png"/></div>
      </div>

      <div id="article">
       
        <p>GD MICE is established to help partners capture growing opportunities in the MICE market.</p>
        <p>We create fully customised corporate and group travel solutions across industries, regions, and business sizes.</p>
        <p>Powered by GD Group Berhad Impact Business Module, GD MICE operates on B2B, B2B2C, and B2C2B models—strengthening partner collaboration, enhancing customer reach, and improving market scalability.</p>
        <p>With the backing of ICE Holidays’ industry experience, financial strength, and strong procurement network, GD MICE delivers:</p>
        <p>Customised programs</p>
        <p>Advantageous cost-performance ratio</p>
        <p>Comprehensive backup support</p>
        <p>Seamless end-to-end arrangements</p>
        <p>From business meetings and incentive trips to conferences and signature group experiences, GD MICE ensures value, reliability, and memorable journeys—supported by our nationwide partner network.</p>
      </div> 
    </div>
  </div>
);

export default MiceAboutPage;